<template>
  <v-dialog v-model="dialogOpen" max-width="520">
    <v-card class="tw-overflow-hidden">
      <v-card-title class="tw-flex tw-items-start tw-justify-between tw-pr-3">
        <div>
          <div class="tw-text-lg tw-font-medium">ยืนยันเอกสาร</div>
          <div class="tw-text-sm tw-text-gray-500 tw-font-normal tw-mt-1 tw-tracking-normal">
            เลือกปลายทางสำหรับยืนยันเอกสารนี้
          </div>
        </div>
        <v-btn icon small @click="close" aria-label="ปิด">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-alert
        v-if="disabledReason"
        type="error"
        text
        dense
        class="tw-tracking-normal tw-mb-0 tw-rounded-none"
      >
        {{ disabledReason }}
      </v-alert>

      <v-list class="tw-py-0">
        <template v-for="(opt, idx) in shownTargets">
          <v-list-item
            :key="opt.value"
            class="target-row"
            :class="{ 'target-row--disabled': isRowDisabled(opt) }"
            two-line
            :disabled="isRowDisabled(opt)"
            @click="onConfirm(opt)"
          >
            <v-list-item-avatar :color="opt.color" size="40" class="tw-flex-shrink-0">
              <v-icon dark>{{ opt.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="tw-text-base tw-font-medium tw-tracking-normal">
                {{ opt.title }}
              </v-list-item-title>
              <v-list-item-subtitle class="tw-tracking-normal tw-text-gray-600">
                {{ opt.subtitle }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="opt.disabled && opt.disabledReason"
                class="tw-tracking-normal tw-text-red-600 tw-mt-1"
              >
                {{ opt.disabledReason }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="idx < shownTargets.length - 1" :key="opt.value + '-d'" inset />
        </template>
      </v-list>

      <v-divider />

      <v-card-actions class="tw-px-4 tw-py-3">
        <v-spacer />
        <v-btn text class="tw-tracking-normal" @click="close">ยกเลิก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "confirm-single-document-dialog",
  props: {
    isOpen: Boolean,
    visibleTargets: {
      type: Array,
      default: () => ["express", "sap", "psc"],
    },
    disabledReason: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      targets: [
        {
          value: "express",
          title: "ส่งเข้า Express",
          subtitle: "ผ่าน FoxPro โดยตรง",
          icon: "mdi-share",
          color: "primary",
          disabled: true,
          disabledReason: "ปิดให้บริการชั่วคราว — กรุณาใช้ Express (PSC) แทน",
        },
        {
          value: "sap",
          title: "ส่งเข้า SAP",
          subtitle: "ผ่าน B1 Service Layer",
          icon: "mdi-database-arrow-right",
          color: "indigo",
        },
        {
          value: "psc",
          title: "ส่งเข้า Express (PSC)",
          subtitle: "ผ่าน PSC Connector → SQL → Express",
          icon: "mdi-connection",
          color: "deep-purple darken-2",
        },
      ],
    };
  },
  computed: {
    dialogOpen: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit("update:isOpen", value);
      },
    },
    shownTargets() {
      const allowed = new Set(this.visibleTargets || []);
      return this.targets.filter((t) => allowed.has(t.value));
    },
    isDisabled() {
      return !!this.disabledReason;
    },
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    isRowDisabled(opt) {
      return this.isDisabled || !!opt.disabled;
    },
    onConfirm(opt) {
      if (this.isRowDisabled(opt)) return;
      this.$emit("confirm", opt.value);
      this.close();
    },
  },
};
</script>

<style scoped>
.target-row {
  transition: background-color 0.15s ease;
  cursor: pointer;
}
.target-row:hover {
  background-color: rgba(0, 0, 0, 0.03);
}
.target-row--disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.target-row--disabled:hover {
  background-color: transparent;
}
</style>
